import { useQuery } from '@apollo/client';
import { GetOrganizationGuestUsers } from '../../../Apollo';
import useNotification from 'Hooks/useNotification';
import OrganizationGuestUsersTable from './OrganizationGuestUsersTable';
import useTableUserSettings from 'Hooks/useTableUserSettings';

interface Props {
  organizationCode: string;
}

function OrganizationGuestUsersTableContainer(props: Readonly<Props>) {
  const { organizationCode } = props;
  const { onError } = useNotification();

  const {
    selectedIds,
    currentPage,
    rowsPerPage,
    orderBy,
    personFilter,
    handleSearch,
    onChangeRowsPerPage,
    onChangeOrderBy,
    onChangePage,
    handleSelect,
    handleUnselect,
    setSelectedIds
  } = useTableUserSettings<string>(organizationCode, '');

  const handleRefetch = () => {
    refetch();
    setSelectedIds([]);
  };

  const variables = {
    organizationCode,
    contactDetails: personFilter ?? null,
    offset: currentPage * rowsPerPage,
    first: rowsPerPage
  };

  const { data, loading: fetching, refetch } = useQuery<
    GetOrganizationGuestUsersData
  >(GetOrganizationGuestUsers, {
    onError,
    variables
  });

  let loading = fetching;
  let rows: { node: IOrganizationGuestPerson }[] = [];
  let totalCount = rowsPerPage;

  if (data?.organizationGuestUsers) {
    rows = data.organizationGuestUsers.edges;
    totalCount = data.organizationGuestUsers.totalCount;
  } else {
    loading = true;
  }

  const selectedCount = selectedIds == null ? totalCount : selectedIds.length;

  return (
    <OrganizationGuestUsersTable
      rows={rows}
      loading={loading}
      selectedCount={selectedCount}
      selectedIds={selectedIds}
      filter={personFilter}
      totalCount={totalCount}
      orderBy={orderBy}
      rowsPerPage={rowsPerPage}
      currentPage={currentPage}
      onSearch={handleSearch}
      onChangeOrderBy={onChangeOrderBy}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onSelect={handleSelect}
      onUnselect={handleUnselect}
      onChangePage={onChangePage}
      onReloadUsers={handleRefetch}
      organizationCode={organizationCode}
    />
  );
}

export default OrganizationGuestUsersTableContainer;
